import { featureItems } from '@/mocks/homeData';

export default function SectionFeatures() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">
            为什么选择我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            2828电影网坚持做好每一个细节，给你最棒的追剧体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 hover:border-primary-300 transition-all duration-300 text-center"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-primary-50 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-950 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}